const experienceScoreStatuses = {
    OPTIMAL: 'Optimal',
    GOOD: 'Good',
    SUB_OPTIMAL: 'Sub Optimal',
    NOT_IDEAL: 'Not Ideal',
} as const;

export const isPositiveStatus = (status?: string) =>
    status === experienceScoreStatuses.OPTIMAL || status === experienceScoreStatuses.GOOD;

export type ExperienceScoreStatus = (typeof experienceScoreStatuses)[keyof typeof experienceScoreStatuses];

export default experienceScoreStatuses;
